import React from 'react';
import {Button} from 'antd';
import {observer} from "mobx-react";
import {Translate} from "../util/translation.util";

const ExportButton: React.FC<{
    exporter: () => Promise<void>,
    translation?: string,
    fileNamePrefix: string,
}> = observer(({ exporter, translation = 'global.button.export', fileNamePrefix}) => {
    return (
        <Button type={`primary`} onClick={async () => {
            await exporter().then(async (response: any) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', fileNamePrefix + '_export.json');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
        }}><Translate message={translation} /></Button>
    );
})

export default ExportButton;